import { GameShellComponent } from './GameShellComponent';
import { GameplayActionEvent } from '../../constants/GameplayActionEvent';
import { BlockWithActionButtonComponent } from './BlockWithActionButtonComponent';
import { BlockWithToggleButtonComponent } from './BlockWithToggleButtonComponent';
import { GameActionEvent } from '../../constants/GameActionEvent';
import { SelectionSetComponent } from './SelectionSetComponent';
import { ResultComp } from './ResultComp';
// import { CacheImages } from '../../../vendors/ngab/load/CacheImages';
import { SureCacheImages } from '../../utils/CacheImages';
import game from '../../../data/game';
import { EventDispatcher } from '../../utils/EventDispatcher';
import { scrollLeaderboardsToActiveItem } from '../../utils/updateLeaderboardsBlocks';
import { YmElements } from './YmElements';
// import { FluentBackComponent } from './FluentBackComponent';

export class View extends EventDispatcher {
    #isStartPage = true;
    #gViewport;
    #sViewport;
    #insertBackBeforeEl;
    #startComp = null;
    #pageComps = null;
    #pageComp = null;
    #extraComps = null;
    #selectionComp = null;
    #resultComp = null;
    #warningComp = null;
    #shellComp = null;
    #playgroundComp = null;
    #snakeComp = null;
    #backComp = null;
    #isSizeFlipped = false;
    #hasSounds = false;
    #mainScreensHidden = false;
    #prevScreenId = null;
    #ymElements = null;

    constructor(hasSounds) {
        super();
        const insertBackBefore = document.querySelector('.page-screen');

        this.#hasSounds = hasSounds || false;

        this.#startComp = new BlockWithActionButtonComponent(document.querySelector('.cover-screen'));
        this.#resultComp = new ResultComp(document.querySelector('.result-screen'));
        this.#pageComps = [...document.querySelectorAll('.page-screen')]
            .map((el) => new BlockWithActionButtonComponent(el));
        this.#extraComps = [...document.querySelectorAll('.extra-screen')]
            .map((el) => new BlockWithToggleButtonComponent(el));
        // this.#backComp = new FluentBackComponent();
        this.#gViewport = document.getElementById('viewport');
        this.#sViewport = document.getElementById('main');
        this.#insertBackBeforeEl = insertBackBefore;

        this.#ymElements = new YmElements();
    }

    // eslint-disable-next-line class-methods-use-this
    async load(progressUpdate) {
        const localProgressUpdate = (from, to, progress) => {
            progressUpdate(from + progress * (to - from));
        };

        // await CacheImages([...game.images], true, (p) => {
        //     localProgressUpdate(0.1, 0.99, p / 100);
        // });
        await SureCacheImages([...game.images], true, (p) => {
            localProgressUpdate(0.1, 0.99, p / 100);
        });
    }

    start() {
        this.#addCompTransferListener(this.#startComp, GameActionEvent);
        this.#pageComps.forEach((comp) => this.#addCompTransferListener(comp, GameActionEvent));
        this.#extraComps.forEach((comp) => this.#addCompTransferListener(comp, GameActionEvent));

        this.#startComp.show();

        this.updateBodyScreen('intro');

        this.#ymElements.init();
    }

    hideStart() {
        if (!this.#isStartPage) return;

        this.#removeCompTransferListener(this.#startComp, GameActionEvent);

        this.#startComp.hide(true, true);

        this.#isStartPage = false;
        this.#startComp = null;
    }

    updateBodyScreen(screenId) {
        this.#prevScreenId = document.body.dataset.activeScreen || null;
        document.body.dataset.activeScreen = screenId;
        document.body.dataset.prevScreen = this.#prevScreenId;

        if (screenId === 'snake') {
            document.body.classList.add('has-gift');
        }
    }

    showExtraScreen(screenId) {
        this.#mainScreensHidden = true;
        document.body.classList.add('hide-main-screens');
        this.updateBodyScreen(screenId);
    }

    hideExtraScreen() {
        this.#mainScreensHidden = false;
        document.body.classList.remove('hide-main-screens');
        this.updateBodyScreen(this.#prevScreenId);
    }

    showPageScreen(pindex) {
        this.#hidePrevComp();

        if (!(this.#pageComps instanceof Array)) {
            console.warn('There\'s no page screens to be displayed.');

            return;
        }
        if (pindex < 0 && pindex > this.#pageComps.length) {
            console.warn(`The wrong page screen index passed:  ${pindex}`);

            return;
        }

        this.updateBodyScreen('rules');

        this.#pageComp = this.#pageComps[pindex];
        this.#pageComp.show();
        // this.#showBack(this.#pageComp);
    }

    hidePageScreen() {
        this.#hidePrevPage();
    }

    showLevelOptions(data, startWithSelection) {
        this.#hidePrevComp();

        this.updateBodyScreen('choose-team');

        const newComp = new SelectionSetComponent(data, startWithSelection);

        this.#selectionComp = newComp;
        this.#addCompTransferListener(newComp, GameActionEvent);
        newComp.renderTo(this.#sViewport, this.#gViewport);
        newComp.show();
        // this.#showBack(newComp);
    }

    hideLevelOptions() {
        this.#hidePrevLevelOptions();
    }

    showResult(data) {
        this.#hidePrevComp();

        // Show
        document.body.classList.add('game-result');

        if (!this.#resultComp) return;

        this.#addCompTransferListener(this.#resultComp, GameActionEvent);
        this.#resultComp.update(data);
        this.#resultComp.show();
        this.updateBodyScreen('results');

        setTimeout(() => {
            scrollLeaderboardsToActiveItem();
        }, 300);
        // this.#showBack(this.#resultComp);
    }

    hideResult() {
        this.#hidePrevResult();

        document.body.classList.remove('game-result');
    }

    showWarning(message) {
        console.log('showWarning or update', message, this);
    }

    hideWarning(message) {
        console.log('hideWarning', message, this);
    }

    // #showBack(syncComp) {
    //     this.#backComp.renderTo(this.#sViewport, this.#insertBackBeforeEl);
    //     this.#backComp.sync(syncComp);
    //     this.#backComp.show();
    // }

    #hidePrevComp() {
        this.#hidePrevPage();
        this.#hidePrevWarning();
        this.#hidePrevLevelOptions();
        this.#hidePrevResult();

        document.body.classList.remove('game-result');
    }

    #hidePrevWarning() {
        if (!this.#warningComp) return;

        this.#warningComp.hide(true);
    }

    #hidePrevPage() {
        if (!this.#pageComp) return;

        this.#pageComp.hide();
    }

    #hidePrevLevelOptions() {
        if (!this.#selectionComp) return;

        this.#removeCompTransferListener(this.#selectionComp, GameActionEvent);
        this.#selectionComp.hide(true, true);
    }

    #hidePrevResult() {
        if (!this.#resultComp) return;

        this.#removeCompTransferListener(this.#resultComp, GameActionEvent);
        this.#resultComp.hide();
    }

    #constructGameplay({ w, h }, { of }) {
        const shellComp = new GameShellComponent(w, h, of, this.#hasSounds);

        shellComp.renderTo(this.#gViewport);
        shellComp.show();
        setTimeout(() => {
            // this.#showBack(this.#shellComp);
        }, 150);

        this.#shellComp = shellComp;
        this.#playgroundComp = shellComp.playgroundComp;
        this.#snakeComp = shellComp.snakeComp;
    }

    startGameplay(size, lifes, lifesViewType = null) {
        if (this.#shellComp) {
            this.updateSize(size);
            this.#shellComp.renderTo(this.#gViewport);
            this.#shellComp.show();
            setTimeout(() => {
                // this.#showBack(this.#shellComp);
            }, 150);
        } else {
            this.#constructGameplay(size, lifes);
            this.#addCompTransferListener(this.#shellComp, GameplayActionEvent);
            this.#addCompTransferListener(this.#shellComp, GameActionEvent);
        }

        // Update
        const { value } = lifes;

        this.#shellComp.score = 0;
        this.#shellComp.lifes = value;
        this.#shellComp.lifesViewType = lifesViewType;

        document.body.classList.add('game-playing');
        this.updateBodyScreen('snake');
        this.#gViewport.classList.add('active');
    }

    stopGameplay() {
        if (!this.#shellComp) return;

        document.body.classList.remove('game-playing');
        this.#gViewport.classList.remove('active');
        this.#shellComp.hide();
    }

    updateSize(size) {
        if (!this.#shellComp) return;

        this.#shellComp.setSize(size.w, size.h);
    }

    clearCells() {
        this.#playgroundComp.clearCells();
        this.#snakeComp.clearCells();
    }

    update(model, force) {
        if (!this.#shellComp) return;

        const isSizeFlipped = model.size.w === this.size.h && model.size.h === this.size.w;
        const isSizeSame = model.size.w === this.size.w && model.size.h === this.size.h;

        if (!isSizeFlipped && !isSizeSame) {
            this.#isSizeFlipped = false;
            console.warn('Size are not compatible');

            return;
        }

        this.#isSizeFlipped = isSizeFlipped;

        if (model.itemsOnPlaygroundChanged || force) {
            this.#playgroundComp.updateCells(model.itemsOnPlayground, isSizeFlipped);
        }

        const {
            snakeCells,
            snakeRemovedCells,
            snakeHeadLength,
            snakeTailLength,
            ateItself,
            complete,
            isPlaying,
            isPlayingChanged,
            lifes,
            lifesChanged,
            score,
            scoreChanged
        } = model;
        const { value } = lifes;

        // console.log(snakeCells, snakeRemovedCells, snakeHeadLength, snakeTailLength, model);
        // console.log(snakeCells.map((c) => c.orientation));
        this.#snakeComp.updateCells(
            snakeCells,
            snakeRemovedCells,
            snakeHeadLength,
            snakeTailLength,
            ateItself,
            complete,
            isSizeFlipped
        );
        if (lifesChanged) this.#shellComp.lifes = value;
        if (scoreChanged) this.#shellComp.score = score;
        if (isPlayingChanged) this.#shellComp.isPlaying = isPlaying;
    }

    #addCompTransferListener(comp, event) {
        this._transferListener = this._transferListener || ((evt) => {
            // TRANSFER AN EVENT
            this.dispatchEvent({
                ...evt,
                target: this
            });
        });

        comp.addEventListener(event, this._transferListener);
    }

    #removeCompTransferListener(comp, event) {
        comp.removeEventListener(event, this._transferListener);
    }

    get size() {
        if (this.#shellComp) return this.#shellComp.size;

        return { w: 0, h: 0 };
    }

    get isFlipped() {
        return this.#isSizeFlipped;
    }

    get mainScreensAreHidden() {
        return this.#mainScreensHidden;
    }
}
